import React, { createContext, useContext, useEffect, useState } from "react";

const LanguageContext = createContext(null);

const STORAGE_KEY = "bb_lang";
// modes: "fr" | "en"
const VALID = ["fr", "en"];

export const LanguageProvider = ({ children }) => {
  const [lang, setLang] = useState(() => {
    if (typeof window === "undefined") return "fr";
    const stored = window.localStorage.getItem(STORAGE_KEY);
    // Migrate legacy "both" → "fr"
    if (stored === "both") return "fr";
    return VALID.includes(stored) ? stored : "fr";
  });

  useEffect(() => {
    if (typeof window !== "undefined") {
      window.localStorage.setItem(STORAGE_KEY, lang);
      document.documentElement.lang = lang === "en" ? "en" : "fr";
    }
  }, [lang]);

  const value = {
    lang,
    setLang,
    isFR: lang === "fr",
    isEN: lang === "en",
    isBoth: false,
  };

  return (
    <LanguageContext.Provider value={value}>{children}</LanguageContext.Provider>
  );
};

export const useLang = () => {
  const ctx = useContext(LanguageContext);
  if (!ctx) throw new Error("useLang must be used inside LanguageProvider");
  return ctx;
};
